
export enum ERecipeViews {
    NEWRECIPE = 1,
    RECIPEHISTORY = 2,
    PATIENTAGENDA = 3,
    PROFILEDATA = 4
}

export enum ESteps {
    PATIENTSTEP = 1,
    MEDICATIONSTEP = 2,
    CONFIRMATIONSTEP = 3
}

export enum ERecipeHistoryTab {
    PENDING = 1,
    FINISHED = 2
}

export enum EAgendaViews {
    PATIENTAGENDAVIEW = 1,
    PATIENTAGENDAWITHPATIENTVIEW = 2,
    CREATEPATIENTVIEW = 3
}

export enum EProfileDataViews {
    PROFILEDATAFORMVIEW = 1,
    PROFILEDATAVIEW = 2
}
export enum ETaskMessageType {
    RECIPES = 1,
    STUDY_ORDERS = 3,
    APPOINTMENTS = 5,
    STUDY_RESULT = 19
}
export enum EMessageType {
    EMAIL = 1,
    WHATSAPP = 2
}